import { useVerificationModal } from '@/features/user-verification';
import { ModalComponentWrapper, Button } from '@/shared/components';
import { useContactUs } from '@/shared/lib';
import { useVerificationStatus } from '@/widgets/user-verification-cta/model/useVerificationStatus';
import { Trans } from 'react-i18next';

interface Props {
  title?: string;
  onBack?: () => void;
}

export function VerificationInfoModal({ title: propTitle, onBack }: Props) {
  const { openVerificationModal } = useVerificationModal();

  const { links } = useContactUs({ ewalletAccNum: '' });

  const {
    icon,
    title,
    description,
    buttonText,
    isVerificationRejected,
    isCorporateSuccess,
  } = useVerificationStatus({ isBlackSuccessIcon: true });

  return (
    <ModalComponentWrapper
      title={propTitle ? propTitle : undefined}
      onBack={onBack ? onBack : undefined}
      contentClassName="overflow-x-hidden">
      <div
        className={
          'flex flex-col justify-between items-center gap-[2.4rem] max-h-[30rem] w-full max-w-[42rem] self-start'
        }>
        <div className="flex flex-col justify-start items-center gap-[2.4rem] w-full max-w-[42rem]">
          <img src={icon} className="w-[5.6rem]" alt="Verification status" />
          <div className="flex flex-col items-center justify-center gap-[0.8rem]">
            <span className="headline4 text-center">{title}</span>
            <p className="p4 text-center text-secondary">
              {isCorporateSuccess ? (
                <Trans
                  i18nKey="personalAccount.verificationCta.corporateSuccessDescription"
                  components={{
                    email: <span className="text-primary font-medium" />,
                  }}
                />
              ) : (
                description
              )}
            </p>
          </div>
        </div>
        {buttonText && (
          <Button
            size="lg"
            onClick={() => {
              if (isCorporateSuccess) {
                window.open(links?.verificationForCorporate || '', '_blank');
              } else if (isVerificationRejected) {
                window.open(links?.defaultRequest || '', '_blank');
              } else {
                openVerificationModal();
              }
            }}>
            {buttonText}
          </Button>
        )}
      </div>
    </ModalComponentWrapper>
  );
}
